import type { FullSpecies, Reference } from '@/types'
import { createContext, useCallback, useContext, useState } from 'react'
type SpeciesDetailContextType = {
  species: FullSpecies | null
  handleHoverData: (referenceId: number | null) => void
  hoveredRef?: Reference
}

const SpeciesDetailContext = createContext<SpeciesDetailContextType>({
  species: null,
  handleHoverData: () => {},
})

export const SpeciesDetailProvider = ({
  species,
  references,
  children,
}: {
  species: FullSpecies
  references: Reference[]
  children: React.ReactNode
}) => {
  const [hoveredRef, setHoveredRef] = useState<Reference>()
  const handleHoverData = useCallback(
    (referenceId: number | null) => {
      const reference = references.find((item) => item.id === referenceId)
      setHoveredRef(reference)
    },
    [references],
  )

  return (
    <SpeciesDetailContext.Provider
      value={{ species, handleHoverData, hoveredRef }}
    >
      {children}
    </SpeciesDetailContext.Provider>
  )
}

export const useSpeciesDetail = () => useContext(SpeciesDetailContext)
